import { render, staticRenderFns } from "./NeedJc.vue?vue&type=template&id=7b8cf000&scoped=true"
import script from "./NeedJc.vue?vue&type=script&lang=js"
export * from "./NeedJc.vue?vue&type=script&lang=js"
import style0 from "./NeedJc.vue?vue&type=style&index=0&id=7b8cf000&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cf000",
  null
  
)

export default component.exports